/** Names + titles for procedural hero generation. */

export const FIRST_NAMES: string[] = [
  'Tormund', 'Brenna', 'Erik', 'Liesel', 'Hagen', 'Asta', 'Bjorn', 'Ingrid',
  'Cael', 'Mira', 'Oskar', 'Yseult', 'Roderic', 'Niamh', 'Ulric', 'Saskia',
  'Conrad', 'Hilde', 'Aldous', 'Freya', 'Garrick', 'Marit', 'Edric', 'Sigrid',
  'Wendel', 'Tyra', 'Dain', 'Linnea',
];

export const TITLES: string[] = [
  'the Bold',
  'the Cautious',
  'the Hollow',
  'Quietfoot',
  'Greybeard',
  'the Wanderer',
  'of the Mire',
  'Ironfist',
  'the Patient',
  'Stormcloak',
  'Whispervoice',
  'the Reckless',
  'of the Vale',
  'the Lost',
];

export const FLAVOR_LINES: string[] = [
  'I face the wolf-king at dawn.',
  'There is a beast in the old quarry.',
  'I will not return empty-handed.',
  'My brother\'s killer waits in the crypts.',
  'The cave will not have me without a fight.',
  'They say only a true blade will pierce the warden.',
  'A bounty draws me north. I need steel.',
  'I am sworn to end this, with your help.',
  'My last blade snapped on bone.',
  'I have heard rumors of you. Make it good.',
  'The dawn raid begins in an hour.',
  'My patron pays in gold; I pay in blood.',
];
